var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_privacy",
    "data-name": "icona privacy",
    transform: "translate(-175 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_privacy-2",
    "data-name": "icona privacy",
    d: "M14.265,2.453,8.665.109a1.4,1.4,0,0,0-1.076,0l-5.6,2.344a1.4,1.4,0,0,0-.863,1.3c0,5.816,3.34,9.836,6.46,11.143a1.4,1.4,0,0,0,1.076,0c2.5-1.046,6.463-4.659,6.463-11.143A1.407,1.407,0,0,0,14.265,2.453ZM8.128,13.077l0-11.163,5.13,2.148c-.1,4.436-2.395,7.65-5.127,9.016Z",
    transform: "translate(174.875 17.998)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_764",
    "data-name": "Rettangolo 764",
    transform: "translate(175 18)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.2e1025da0a1314bccd059d8bef4a0cc3.svg";
export { ForwardRef as ReactComponent };